import { article, section } from "~/data";

export const HidePlayerBySectionEntityIds = [
  section.infographics.entityId,
  section.style.entityId,
  section.video.entityId,
  section.scmpFilms.entityId,
  section.podcasts.entityId,
  section.cooking.entityId,
];

export const HidePlayerByTypeEntityIds = [article.types.live.entityId];
export const NumberOfCharacterShow = 45;
